<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 40 21.763"
    enable-background="new 0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
  >
    <g transform="matrix(.68009 0 0 .68009 -1.763 -10.882)">
      <path
        :fill="color"
        d="m60.885 30.498s-12.232-14.498-28.885-14.498c-16.652 0-28.885 14.498-28.885 14.498-0.697 0.826-0.697 2.178 0 3.005 0-1e-3 12.233 14.497 28.885 14.497s28.884-14.498 28.884-14.498c0.698-0.826 0.698-2.178 1e-3 -3.004zm-28.885 13.819c-6.802 0-12.317-5.514-12.317-12.317s5.515-12.317 12.317-12.317 12.317 5.515 12.317 12.317-5.514 12.317-12.317 12.317z"
      />
      <path
        :fill="color"
        d="m37.809 29.423c-1.447 0-2.621-1.173-2.621-2.621 0-0.378 0.081-0.738 0.225-1.062-1.014-0.554-2.177-0.869-3.413-0.869-3.937 0-7.129 3.192-7.129 7.129s3.192 7.13 7.129 7.13 7.129-3.192 7.129-7.129c0-0.955-0.189-1.866-0.53-2.699-0.249 0.078-0.515 0.121-0.79 0.121z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PasswordViewSvg',
  props: {
    width: {
      type: [Number, String],
      default: '40'
    },
    height: {
      type: [Number, String],
      default: '21.763'
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
}
</script>
